<template>
    <sup>
        Archived
    </sup>
</template>

<script>
export default {
    name: 'analysis-archived',
}
</script>

<style scoped>
sup {
    padding: 1px 4px 1px 2px;
    background-color: #3572b9;
    color: white;
    margin-left: 10px;
    font-weight: 400;
}
</style>
